import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComissaoFaturamentoComponent } from './comissao-faturamento.component';

const routes: Routes = [
  {
    path: '',
    component: ComissaoFaturamentoComponent,
    title: 'Comissão de Faturamento',
    children: [{ path: ':mode', redirectTo: '', pathMatch: 'full' }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComissaoFaturamentoRoutingModule {}
